export const UNIT_THEMES = {
  santa_clara: {
    name: "Posto Santa Clara",
    header: "bg-blue-600 text-white border-b-4 border-blue-800",
    primary: "bg-blue-600 hover:bg-blue-700 text-white",
    primaryText: "text-blue-700",
    activeNav: "bg-blue-50 text-blue-900 border-l-4 border-blue-600",
    hoverNav: "hover:bg-blue-50 hover:text-blue-900",
    ring: "focus-visible:ring-blue-600",
    badge: "bg-blue-600 text-white",
    softBg: "bg-blue-50",
    border: "border-blue-600",
    shadow: "shadow-brutal-blue",
    hex: "#2563EB",
  },
  lacador: {
    name: "Posto Laçador",
    header: "bg-red-600 text-white border-b-4 border-red-800",
    primary: "bg-red-600 hover:bg-red-700 text-white",
    primaryText: "text-red-700",
    activeNav: "bg-red-50 text-red-900 border-l-4 border-red-600",
    hoverNav: "hover:bg-red-50 hover:text-red-900",
    ring: "focus-visible:ring-red-600",
    badge: "bg-red-600 text-white",
    softBg: "bg-red-50",
    border: "border-red-600",
    shadow: "shadow-brutal-red",
    hex: "#DC2626",
  },
  master: {
    name: "Painel Master",
    header: "bg-neutral-950 text-white border-b-4 border-yellow-400",
    primary: "bg-neutral-950 hover:bg-neutral-800 text-white",
    primaryText: "text-neutral-900",
    activeNav: "bg-neutral-100 text-neutral-950 border-l-4 border-yellow-400",
    hoverNav: "hover:bg-neutral-100",
    ring: "focus-visible:ring-neutral-950",
    badge: "bg-yellow-400 text-neutral-950",
    softBg: "bg-neutral-100",
    border: "border-neutral-950",
    shadow: "shadow-brutal-yellow",
    hex: "#0A0A0A",
  },
};

export const getTheme = (slug) => UNIT_THEMES[slug] || UNIT_THEMES.master;
